import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import MenuItem from './MenuItem';
import CollapsibleMenuItem from './CollapsibleMenuItem';
import { List } from './MenuStyle';
import { connect } from 'react-redux';
import { compose } from 'redux';

function Menu({ drawerOpen, withGradient, userInfo }) {
  const location = useLocation();

  const activeRoute = useCallback(routeName => location.pathname.indexOf(routeName) > -1, [location.pathname]);

  const menuItems = useMemo(() => userInfo.menuItems, [userInfo]);

  return (
    <nav>
      <List>
        {menuItems.map((menu, key) => {
          const menuItemProps = { key, menu, drawerOpen, activeRoute, withGradient };
          return menu.children ? <CollapsibleMenuItem {...menuItemProps} /> : <MenuItem {...menuItemProps} />;
        })}
      </List>
    </nav>
  );
}

Menu.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  withGradient: PropTypes.bool.isRequired,
  userInfo: PropTypes.object
};

function mapStateToProps(state) {
  let userRole;
  if (state.oidc.user?.profile?.role) userRole = state.oidc.user.profile.role;
  return { userRole, userInfo: state.userInfo };
}

export default compose(connect(mapStateToProps))(Menu);
